export default "__VITE_ASSET__BonJWI8B__"